import React from 'react';
import { useTranslation } from 'react-i18next';
import StrategySelectionModal from '../../../common/StrategySelectionModal/StrategySelectionModal';
import { PRIVILEGE_CHANGE_STRATEGIES } from '../../../../constants/role.constant';

const strategies = [
  {
    value: PRIVILEGE_CHANGE_STRATEGIES.RESET,
    labelKey: 'roleEdit.resetAllOption',
    descriptionKey: 'roleEdit.resetAllDescription',
  },
  {
    value: PRIVILEGE_CHANGE_STRATEGIES.SYNC,
    labelKey: 'roleEdit.syncAllOption',
    descriptionKey: 'roleEdit.syncAllDescription',
  },
  {
    value: PRIVILEGE_CHANGE_STRATEGIES.KEEP,
    labelKey: 'roleEdit.keepAllOption',
    descriptionKey: 'roleEdit.keepAllDescription',
  },
];

const CustomUsersModal = ({ open, onClose, onSelectStrategy, usersCount }) => {
  const { t } = useTranslation();

  return (
    <StrategySelectionModal
      open={open}
      onClose={onClose}
      onSelectStrategy={onSelectStrategy}
      title={t('roleEdit.customUsersTitle')}
      message={t('roleEdit.customUsersMessage', { count: usersCount })}
      strategies={strategies}
      footnote={t('roleEdit.matchingPrivilegesNote')}
      id="custom-users-modal"
    />
  );
};

export default CustomUsersModal;
